import utils from '@/utils.js'

b64EncodeUnicode = (str) ->
    # // first we use encodeURIComponent to get percent-encoded UTF-8,
    # // then we convert the percent encodings into raw bytes which
    # // can be fed into btoa.
    return btoa(encodeURIComponent(str).replace(/%([0-9A-F]{2})/g,
        (match, p1) ->
            return String.fromCharCode('0x' + p1)
    ))

uuid4 = ->
  'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace /[xy]/g, (c) ->
    r = Math.random() * 16 | 0
    v = if c == 'x' then r else r & 0x3 | 0x8
    v.toString 16

# ---
check_modified_fields = (store)->
    allow = true
    notify_text = "Les champs suivants ne seront pas enregistrés si vous continuez" +
        "<ul style='list-style:disc;margin-left:10px;'>"
    for key of store.state.edited_fields
        f = store.state.edited_fields[key]
        # console.log("check_modified_fields", f, f.el)
        if [null, ""].indexOf(f.value) < 0 
            allow = false;
            notify_text += "<li>" + f.verbose_name + "</li>";
            utils.highlight_element(f.el, 2)
            f.el.focus()
    
    notify_text += "</ul>";
    return {
        allow: allow,
        notify_text: notify_text
    }




export default {
    "deep_copy": (obj)->
        return JSON.parse(JSON.stringify(obj))
    "b64_encode": b64EncodeUnicode,
    "uuid4": uuid4,
    "check_modified_fields": check_modified_fields
}
